import { MemberList } from '@tribeplatform/react-components/MemberList'

import { BC } from '../../types/index.js'
import { MemberListProps } from './types.js'

/**
 * @deprecated use MembersBlock instead
 */
export const MemberListBlock: BC<MemberListProps> = MemberList
